<template>
  <div class="processos-pagamento">
    <div class="row">
      <div class="col-xs-12">
        <button
          type="button"
          class="btn btn-primary btn-voltar"
          @click="$router.back()"
        >
          <font-awesome-icon :icon="'arrow-left'" />
          Voltar
        </button>
        <h1 class="page-header">{{ label }} Processo de Pagamento</h1>
        <div class="row">
          <div class="col-xs-12">
            <div class="col-xs-12 col-sm-4">
              <div
                :class="['form-group', { 'has-error': errors.has('valor') }]"
              >
                <label
                  :class="[
                    'control-label',
                    'primary',
                    { 'is-danger': errors.has('valor') }
                  ]"
                  >Valor</label
                >
                <div class="inputgroupcontainer">
                  <div class="input-group">
                    <span class="input-group-addon">
                      <font-awesome-icon
                        :icon="'money-bill'"
                        :class="[
                          { 'is-danger': errors.has('numero_pagamento') }
                        ]"
                      />
                    </span>
                    <money
                      ref="valor"
                      v-model="model.valor"
                      name="valor"
                      placeholder="Valor da emenda"
                      v-validate="'required|min_value:1.00'"
                      maxlength="22"
                      type="text"
                      v-bind="money"
                      :class="['form-control']"
                    />
                  </div>
                  <small
                    v-if="errors.has('valor')"
                    data-bv-validator="notEmpty"
                    data-bv-validator-for="valor"
                    class="help-block"
                    style=""
                  >
                    <font-awesome-icon :icon="'exclamation-triangle'" />
                    {{ errors.first('valor') }}
                  </small>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-4">
              <div
                :class="[
                  'form-group',
                  { 'has-error': errors.has('numero_pagamento') }
                ]"
              >
                <label
                  :class="[
                    'control-label',
                    'primary',
                    { 'is-danger': errors.has('numero_pagamento') }
                  ]"
                >
                  Número
                </label>
                <div class="inputGroupContainer">
                  <div class="input-group">
                    <span class="input-group-addon"
                      ><font-awesome-icon
                        :icon="'money-check-alt'"
                        :class="[
                          { 'is-danger': errors.has('numero_pagamento') }
                        ]"
                      ></font-awesome-icon
                    ></span>
                    <input
                      type="text"
                      ref="numero_pagamento"
                      name="numero_pagamento"
                      v-validate="'required|min:9'"
                      maxlength="15"
                      data-vv-as="número de pagamento"
                      v-model="model.numero_pagamento"
                      :class="[
                        'form-control',
                        { 'is-danger': errors.has('numero_pagamento') }
                      ]"
                      placeholder="Número com formato"
                    />
                  </div>
                  <small
                    v-if="errors.has('numero_pagamento')"
                    data-bv-validator="notEmpty"
                    data-bv-validator-for="numero_pagamento"
                    class="help-block"
                    style=""
                  >
                    <font-awesome-icon :icon="'exclamation-triangle'" />
                    {{ errors.first('numero_pagamento') }}
                  </small>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-4">
              <div class="form-group">
                <label class="control-label primary">Número da emenda</label>
                <div class="custom-select">
                  <select
                    ref="emenda_id"
                    class="form-control select-selected"
                    name="emenda_id"
                    data-vv-as="número da emenda"
                    v-model="model.emenda_id"
                    v-validate="'required'"
                  >
                    <option
                      v-for="emenda in emendas"
                      :key="emenda.id"
                      :value="emenda.id"
                    >
                      {{ emenda.numero }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-group col-xs-12" style="margin-top:30px">
              <button
                @click="save()"
                class="btn btn-default"
                :disabled="carregando"
              >
                <font-awesome-icon v-if="carregando" :icon="'spinner'" spin />
                <font-awesome-icon v-else :icon="'save'" />
                Salvar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask'
import { request } from '@/request'

export default {
  name: 'processos-pagamento-save',
  data() {
    return {
      label: 'Adicionar',
      emendas: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      model: {
        numero_pagamento: '',
        valor: '',
        emenda_id: ''
      },
      carregando: false
    }
  },
  components: {
    TheMask
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  mounted() {
    const { id } = this.$route.params
    const { codigo_emenda } = this.$route.params
    if (id) {
      this.label = 'Editar'
      this.loadModel(id)
    } else if (codigo_emenda) {
      this.loadEmendas()
      this.model.emenda_id = codigo_emenda
    } else {
      this.loadEmendas()
    }
  },
  methods: {
    fetchEmendas() {
      return request.get('emenda')
    },
    async loadEmendas() {
      const respEmenda = await this.fetchEmendas()
      this.emendas = respEmenda.data.data
    },
    async loadModel(id) {
      const response = await request.get(`processospagamento/${id}`)

      const responseEmendas = await this.fetchEmendas()

      this.emendas = responseEmendas.data.data

      this.model = response.data
    },
    toogleLoading() {
      this.carregando = !this.carregando
    },
    saveSuccess(result) {
      this.$toastr.s('Processo de pagamento salvo com sucesso.')
      this.$router.back()
    },
    saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item.')
      this.toogleLoading()
    },
    save() {
      this.toogleLoading()
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.toogleLoading()
          this.$refs[this.$validator.errors.items[0].field]
          this.$toastr.e(this.$validator.errors.items[0].msg)
          return
        }
        if (this.model.codigo) {
          request
            .put(`processospagamento/${this.model.codigo}`, this.model)
            .then(this.saveSuccess)
            .catch(this.saveFail)
        } else {
          request
            .post('processospagamento', this.model)
            .then(this.saveSuccess)
            .catch(this.saveFail)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/emendas-parlamentares/processos-pagamento/Save.vue